
import ErrorSerializer from '~/serializer/Error'

export default {
  name: 'GGSaleSection',
  inject: ['emitter'],
  props: {
    request: {
      type: Function,
      required: true,
    },
    onSaleClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      list: [],
      active: false,
    }
  },
  async fetch() {
    try {
      this.list = (await this.request())?.list || []
      this.active = true
    }
    catch (e) {
      const error = ErrorSerializer(e)
      new this.$baseError(error)
    }
    this.$emit('create')
  },
  methods: {
    saleSelect() {
      this.onSaleClick()
    },
  },
}
